import { Injectable } from '@angular/core';
import Axios, { AxiosInstance } from "axios";
import * as moment from 'moment';
import { ILogMessage } from './interfaces'

@Injectable({
  providedIn: 'root'
})
export class Logger {
  private axiosClient: AxiosInstance;

  private static isDebug: boolean = true
  private static logLevel: string = "H"
  private static logs: string[] = []
  private static apikey: string = ""
  private static url: string = ""
  private static loggerUrl: string = "not-defined"
  private static lang: string = "cs"
  private static parentApp: string = "web"
  private static jwtToken: string = ""

  private static shouldSendNow: boolean = false



  constructor() {

  }

  static setConfig(apikey: string, parentApp: string, lang: string, url: string, isDebug: boolean) {
    this.apikey = apikey
    this.url = url
  
    this.lang = lang
    this.parentApp = parentApp
    this.isDebug = isDebug
    this.shouldSendNow = true

    if (isDebug) {
      this.logLevel = "H"
    } else {
      this.logLevel = "V"
    }
    
    //this.uploadLogs(`CH:Logger:setConfig: CHATBOT STARTED with: ${this.apikey} for lang: ${this.lang}, app type: ${this.parentApp}, using server: ${this.url}`,'info')
    
  }


  static startDebug() {
    this.isDebug = true
    let c = 0
    for (let str of this.logs){

      console.log(str)
      console.log(`${c}: ---------------------------------------------------------------------------------------------------------------- LOG AUDIT`)
      c += 1
    }
    console.log(`END OF ***************************************************************************************************************** LOG AUDIT`)

    
  }




  static isLoggingOn(text, severity) {
    if (this.isDebug) {
      //loguje na konzoli a posila na server
      
        
      return true
    } else {
      
      return false;
    }
  }

  


  static trace(text) {
    this.logs.push(`ERR: ${text}`)
    if (this.isLoggingOn(text, 'trace')) {
      console.trace(text);
    }

  }

  static debug(text) {
    this.logs.push(`DEBUG: ${text}`)
    if (this.isLoggingOn(text, 'debug')) {
      console.debug(text);
    }

  }

  static log(text) {
    this.logs.push(`INFO: ${text}`)
    if (this.isLoggingOn(text, 'log')) {
      //console.log(text);
    }

  }

  static version(text) {
    
    
    console.info(text);
    

  }

  static info(text) {
    this.logs.push(`INFO: ${text}`)
    if (this.isLoggingOn(text, 'info')) {
      console.info(text);
    }
  }

  static warn(text) {
    this.logs.push(`WARN: ${text}`)
    if (this.isLoggingOn(text, 'warn')) {
      console.warn(text);
    }
  }

  static error(text) {
    this.logs.push(`ERR: ${text}`)
    if (this.isLoggingOn(text, 'error')) {
      console.error(text);
    }

  }
}
